<!--
 * @Date: 2020-09-01 14:41:39
 * @Author: MX
 * @LastEditTime: 2020-11-24 11:42:13
 * @Description:个人中心
-->
<template>
  <div class="personalCenter main-wrap" id="personalCenter">
    <div class="personalCenter-wrap">
      <div class="main-left">
        <div class="main-left-header">
          <span class="line"></span>
          {{ $lang('个人中心') }}
        </div>
        <div class="main-left-aside">
          <img src="@/assets//images/register/head2.png" alt="" />
          <div class="username">
            {{ user.account }}
          </div>
          <div
            class="main-left-aside-item"
            v-for="(item, index) in asideList"
            :key="index"
            :class="{ first: index === 0, active: tabActive === index }"
            @click="tabTip(index)"
          >
            <span v-if="item.level <= authLevel">{{ $lang(item.label) }}</span>
          </div>
        </div>
      </div>
      <!-- 开发者信息认证状态 -->
      <div class="audit-status" v-if="tabActive === 1">
        <div><i class="iconfont " :class="{ iconshenhezhuangtai_weishenqingshibai: auditStatus === ''|| auditStatus === 3, iconshenhezhuangtai_shenhezhong: auditStatus === 0|| auditStatus === 1, iconshenhezhuangtai_tongguo: auditStatus === 2}"></i>{{ $lang('审核状态') }}：<span>{{auditStatus | $lang(statusFilter)}}</span>
        </div>
        <div  class="reason" v-if="auditStatus === 3">{{ $lang('失败原因') }}：<span :title="failReason">{{failReason}}</span></div>
      </div>
      <!-- 企业认证信息认证状态 -->
      <div class="audit-status" v-if="tabActive === 2">
        <div><i class="iconfont " :class="{ iconshenhezhuangtai_weishenqingshibai: auditStatus === ''|| auditStatus === 0 || auditStatus === 3, iconshenhezhuangtai_shenhezhong: auditStatus === 1, iconshenhezhuangtai_tongguo: auditStatus === 2}"></i>{{ $lang('审核状态') }}：<span>{{auditStatus | $lang(statusFilter2) }}</span>
        </div>
        <div  class="reason" v-if="auditStatus === 3">{{ $lang('失败原因') }}：<span :title="failReason">{{failReason}}</span></div>
      </div>
      <div class="main-right" v-if="tabActive === 0 && !editing">
        <div class="main-right-item">
          <h3><i class="iconfont iconkongzhitai_farenxinxi"></i>{{ $lang('基础信息') }}</h3>
          <el-form label-width="180px">
            <el-form-item :label="$lang('账号') + '：'">
              <el-input v-model="user.account" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('手机号码') + '：'">
              <el-input v-model="user.phone" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="邮箱账号：">
                                <el-input disabled></el-input>
                        </el-form-item> -->
          </el-form>
          <button class="commonBtn editBtn" @click.prevent="edit">{{ $lang('修改') }}</button>
        </div>
        <div class="main-right-item second" v-if="baseInfo.apiAccount">
          <h3>
            <i class="iconfont icongerenzhongxin_yonghupeizhi"></i>{{ $lang('用户配置') }}
          </h3>
          <el-form label-width="180px">
            <el-form-item label="apiAccount：">
              <el-input v-model="baseInfo.apiAccount" disabled></el-input>
            </el-form-item>
            <el-form-item label="privateKey：">
              <el-input v-model="baseInfo.privateKey" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('来源代码') + '：'">
              <el-input v-model="baseInfo.orderCode" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('来源名称') + '：'">
              <el-input v-model="baseInfo.orderSource" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="main-right-edit" v-if="tabActive === 0 && editing">
        <div class="main-right-edit-header">
          <span
            class="typeItem"
            :class="{ activeType: type === 1 }"
            @click="changeType(1)"
          >{{ $lang('手机号码') }}</span
          >
          <!-- <span class="typeItem" :class="{activeType:type === 2}" @click="changeType(2)">邮箱账号</span> -->
        </div>
        <div class="main-right-edit-content" v-show="type === 1">
          <el-form label-width="210px">
            <el-form-item :label="$lang('新手机号码') + '：'">
              <el-input
                v-model="editForm.phone"
                :placeholder="$lang('请输入新手机号码')"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('验证码') + '：'" class="phoneCodeItem">
              <el-input
                v-model="editForm.captcha"
                :placeholder="$lang('请输入验证码')"
                maxlength="8"
              ></el-input>
              <button
                class="sendcodeBtn commonBtn"
                @click.prevent="sendCodeBefore"
                :disabled="isSendCode || sendLoading"
                v-loading="sendLoading"
              >
                <span v-if="!isSendCode">{{ $lang('发送') }}</span>
                <span v-else>{{ time + $lang('秒') }}</span>
              </button>
            </el-form-item>
          </el-form>
        </div>
        <div class="main-right-edit-content" v-show="type === 2">
          <el-form label-width="210px">
            <el-form-item :label="$lang('邮箱') + '：'">
              <el-input disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('验证码') + '：'">
              <el-input disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-group">
          <button class="commonBtn bindphone" @click.prevent="editPhone">
            {{ $lang('修改') }}
          </button>
          <button class="commonBtn cancel" @click.prevent="cancel">{{ $lang('取消') }}</button>
        </div>
      </div>
      <div class="main-right" v-if="tabActive === 1">
        <div class="main-right-item">
          <h3><i class="iconfont iconkongzhitai_farenxinxi"></i>{{ $lang('开发者信息') }}</h3>
          <el-form label-width="180px">
            <el-form-item :label="$lang('IT接口联系人') + '：'">
              <el-input v-model="userDev.userName" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('IT联系电话') + '：'">
              <el-input v-model="userDev.userPhone" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('IT接口邮箱') + '：'">
              <el-input v-model="userDev.userEmail" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="main-right-item second">
          <h3><i class="iconfont iconapiwendang_jianjie"></i>{{ $lang('公司信息') }}</h3>
          <el-form label-width="180px">
            <el-form-item :label="$lang('公司全称') + '：'">
              <el-input v-model="userDev.enterpriseName" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司地址') + '：'">
              <el-input
                v-model="userDev.userDetailedAddress"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司类型') + '：'">
              <!-- <el-input v-model="userDev.enterpriseType" disabled></el-input> -->
              <el-select
                v-model="userDev.enterpriseType"
                disabled
                :placeholder="$lang('请选择')"
              >
                <el-option
                  v-for="item in enterpriseTypeOptions"
                  :key="item.value"
                  :label="$lang(item.label)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <button class="commonBtn editBtn" @click.prevent="companyAuth">{{ $lang('修改') }}</button>
        </div>
      </div>
      <div class="main-right" v-if="tabActive === 2">
        <div class="main-right-item">
          <h3><i class="iconfont iconkongzhitai_farenxinxi"></i>{{ $lang('法人信息') }}</h3>
          <el-form label-width="180px">
            <el-form-item :label="$lang('姓名') + '：'">
              <el-input
                v-model="userCompany.corporationName"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('身份证号码') + '：'">
              <el-input
                v-model="userCompany.corporationCardId"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('身份证地址') + '：'">
              <el-input v-model="idCardAddress" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('身份证照片') + '：'">
              <div class="uploadImg">
                <img :src="idCardImageUrl" alt="" />
              </div>
              <div class="uploadImg" style="margin-left:20px">
                <img :src="idCardBackImageUrl" alt="" />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="main-right-item second">
          <h3><i class="iconfont iconapiwendang_jianjie"></i>{{ $lang('企业信息') }}</h3>
          <el-form label-width="180px">
            <el-form-item :label="$lang('社会统一信用代码') + '：'">
              <el-input
                v-model="userCompany.socialCreditCode"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('营业执照') + '：'">
              <div class="uploadImg">
                <img :src="businessLicenseImageUrl" alt="" />
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { RESPONSE_SUCCESS } from '@/constants'
// import { VALIDATION } from '@/constants/rules'
// import '@/assets/js/TCaptcha'
export default {
  name: 'personalCenter',
  props: {},
  components: {},
  data() {
    return {
      tabActive: 0,
      authLevel: 0, //已认证等级
      auditStatus: '',
      asideList: [
        {
          label: '个人信息',
          level: 0,
        },
        {
          label: '开发者信息',
          level: 1,
        },
        {
          label: '企业信息',
          level: 2,
        },
      ],
      editing: false,
      type: 1, //个人中心修改type
      editForm: {
        captcha: '',
        phone: '',
      },
      sendLoading: false, // 发送验证码loading
      isSendCode: false,
      time: 60,
      codeTimer: null,
      userDev: {}, //开发者信息
      userCompany: {}, //公司信息
      idCardAddress: '',
      enterpriseTypeOptions: [
        {
          value: 1,
          label: '平台',
        },
        {
          value: 2,
          label: '软件供应商',
        },
        {
          value: 3,
          label: '商家自研系统',
        },
        {
          value: 4,
          label: '其他',
        },
      ],
      baseInfo: {},
      businessLicenseImageUrl: '', //营业执照
      idCardImageUrl: '', //身份证正面照片
      idCardBackImageUrl: '', //身份证正面照片
      captcha:"",//腾讯验证码
      failReason: '' // 失败原因
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.getCertificationInfo()
    this.initTencentCaptcha();
  },
  destroyed() {
    clearInterval(this.codeTimer)
  },
  filters: {
    statusFilter(val){
      return val === 0 || val === 1? '审核中' : (val === 2? '认证通过' : (val === 3? '认证不通过' : '未申请'))
    },
    statusFilter2(val){
      return val === 1? '审核中' : (val === 2? '认证通过' : (val === 3? '认证不通过' : '未申请'))
    }
  },
  methods: {
    //左侧点击
    tabTip(num) {
      this.tabActive = num
    },
    //修改
    edit() {
      this.editing = true
    },
    //开发者信息修改至开发者信息认证
    companyAuth() {
      this.$router.push({ name: 'Control', params: {updateDevCer:true} })
    },
    //tab改变
    changeType(num) {
      this.type = num
    },
    //取消
    cancel() {
      this.editing = false
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = window.CaptchaSDK && window.CaptchaSDK.init(this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // 调用登陆
        this.sendCode(customParams)

        return res
      }
      // 验证不成功
      return null
    },

    //修改手机号
    editPhone() {
      if (!this.editForm.phone || !this.editForm.phone) {
        return this.$message.warning(this.$lang('请输入手机号和验证码'))
      }
      this.$API.changePhone(this.editForm).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('修改手机号成功'))
          this.cancel()
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
    },
    sendCodeBefore(){
      if (!this.editForm.phone) {
        return this.$message.warning(this.$lang('请输入手机号'))
      }
      // if (!VALIDATION.phoneNumber.value.test(this.editForm.phone)) {
      //   return this.$message.warning('请输入正确的手机号')
      // }
      this.captcha.show()
    },
    /**
     * @description 修改手机号发送验证码
     */
    async sendCode({ticket,randstr}) {
      this.sendLoading = true
      let params = {
        phone: this.editForm.phone,
        type: 'change_phone',
        ticket,
        randstr
      }
      await this.$API.sendMessage(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.time = 60
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success(this.$lang('获取手机验证码成功'))
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
      this.sendLoading = false
    },
    /**
     * @description 查询认证信息
     */
    getCertificationInfo() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.auditStatus = !res.data.auditStatus && res.data.auditStatus !== 0 ? '' : res.data.auditStatus // 获取状态
          console.log(this.auditStatus);
          this.baseInfo = res.data
          this.userDev = res.data.userDev
          this.userCompany = res.data.userCompany
          // 如果已经提交了企业信息认证
          if(this.userCompany) {
            this.failReason = res.data.userCompany.remark || '' // 审核失败的原因，如果有
            this.idCardAddress = `${this.userCompany.corporationProvinceName}${this.userCompany.corporationCityName}${this.userCompany.corporationAreaName}${this.userCompany.corporationDetailedAddress}`
            //营业执照照片
            this.$API
              .getImgUrl({ path: this.userCompany.businessLicensePath })
              .then((res) => {
                this.businessLicenseImageUrl = res.data[0] || ''
              })
            //身份证正面照片
            let params1 = {
              path: this.userCompany.corporationPhotoPath.split(',')[0] || '',
            }
            this.$API.getImgUrl(params1).then((res) => {
              this.idCardImageUrl = res.data[0] || ''
            })
            //身份证反面照片
            let params2 = {
              path: this.userCompany.corporationPhotoPath.split(',')[1] || '',
            }
            this.$API.getImgUrl(params2).then((res) => {
              this.idCardBackImageUrl = res.data[0] || ''
            })
          }

          if (res.data.userDev) {
            //已进行开发者认证
            this.authLevel = 1
          }
          if (res.data.userCompany) {
            //已进行企业认证
            this.authLevel = 2
          }
          console.log(this.authLevel)
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.personalCenter {
  background: #f4f5f7;
  .personalCenter-wrap {
    padding: 20px 0;
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    position: relative;
    .audit-status {
      position: absolute;
      right: 60px;
      top: 50px;
      font-size: 14px;
      text-align: right;
      .iconfont {
        margin-right: 6px;
        font-size: 14px;
      }
      .iconshenhezhuangtai_weishenqingshibai {
        color: #E60012;
      }
      .iconshenhezhuangtai_shenhezhong {
        color: rgb(45, 124, 255);
      }
      .iconshenhezhuangtai_tongguo {
        color: rgb(34, 206, 136);
      }
      span{
        color: #E60012;
      }
    }
    .main-left {
      width: 240px;
      box-sizing: border-box;
      margin-right: 20px;
      background: #fff;
      .main-left-header {
        position: relative;
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-size: 26px;
        font-weight: 900;
        line-height: 26px;
        padding: 22px 0 22px 20px;
        box-sizing: border-box;
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
      }
      .main-left-aside {
        text-align: center;
        img {
          width: 72px;
          height: 72px;
          margin: 30px 0 10px;
        }
        .username {
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
        }
        .main-left-aside-item {
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
          margin-top: 34px;
          cursor: pointer;
          &.first {
            margin-top: 47px;
          }
          &.active {
            color: $theme-color;
            font-weight: 600;
          }
        }
      }
    }
    .main-right {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      padding: 50px 30px 15px;
      overflow: auto;
      .main-right-item {
        h3 {
          font-size: 22px;
          color: #2b2d42;
          line-height: 22px;
          margin-bottom: 20px;
          .iconfont {
            color: $theme-color;
            font-size: 24px;
            margin-right: 16px;
          }
        }
        &.second {
          margin-top: 50px;
        }
      }
    }
    .main-right-edit {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      .main-right-edit-header {
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-weight: 900;
        box-sizing: border-box;
        font-size: 22px;
        line-height: 70px;
        padding-left: 30px;
        .typeItem {
          cursor: pointer;
          display: inline-block;
          &:last-of-type {
            margin-left: 50px;
          }
          &.activeType {
            color: $theme-color;
            border-bottom: 2px solid $theme-color;
          }
        }
      }
      .main-right-edit-content {
        padding-top: 50px;
      }
      .btn-group {
        margin-left: 464px;
      }
      .bindphone {
        width: 88px;
        height: 40px;
        background: $theme-color;
        font-size: 14px;
        color: #fff;
      }
      .cancel {
        width: 88px;
        height: 40px;
        background: #fff;
        border: 1px solid #b0b3b6;
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .editBtn {
      width: 120px;
      height: 40px;
      background: $theme-color;
      color: #fff;
      margin-left: 180px;
      font-size: 14px;
    }
  }
  .phoneCodeItem {
    position: relative;
    .sendcodeBtn {
      position: absolute;
      width: 60px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      right: 10px;
      top: 4px;
      border: 1px solid #c4c8cc;
    }
  }
  .uploadImg {
    width: 200px;
    height: 113px;
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss">
.personalCenter {
  .el-form-item__label {
    color: #4c4d57;
  }
  .el-input {
    width: 450px;
  }
  .el-form {
    width: 660px;
  }
}
</style>
<style lang="scss">
#personalCenter {
  .el-loading-spinner{
    margin-top: -10px;
    .circular {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
